import axios from "src/interceptor-servel";

const ApiServelUrl = `${process.env.VUE_APP_API_SERVEL}`;

export const requesServelMixin = {
  methods: {
    getPartidoafiliadosByToken,
    getRegistronombreapellido,
    getRegistroAvanzado,
    getPartidoAfiliadoHistorico,
    getFechaMaximaReclamacion,
  },
};

export const servelService = {
  getRegistronombreapellido,
  getRegistrodomicilio,
  getPartidopartidosregion,
  getPartidopartidosid,
  getPartidoafiliadosByToken,
  getFechaMaximaReclamacion,
  validarCedula,
};

function getRegistronombreapellido() {
  return axios.post(`${ApiServelUrl}/private/registronombreapellido`);
}

function getRegistrodomicilio() {
  return axios.post(`${ApiServelUrl}/private/registrodomicilio`);
}

function getPartidopartidosregion(body) {
  return axios.post(`${ApiServelUrl}/restricted/partidopartidosregion`, body);
}

function getPartidopartidosid(partidoId, codRegion) {
  const body = { id: partidoId, region: codRegion };
  return axios.post(`${ApiServelUrl}/restricted/partidopartidosid`, body);
}

function getPartidoafiliadosByToken() {
  return axios.post(`${ApiServelUrl}/restricted/partidoafiliados`);
}

function getRegistroAvanzado() {
  return axios.post(`${ApiServelUrl}/private/registroavanzado`);
}

function getPartidoAfiliadoHistorico() {
  return axios.post(`${ApiServelUrl}/restricted/partidoafiliadoshistorico`);
}

function getFechaMaximaReclamacion(body) {
  return axios.post(`${ApiServelUrl}/utils/dias/habiles`, body);
}

function validarCedula(run, ndocumento) {
  const body = { 
    run: run,
    ndocumento: ndocumento.replace(/\./g, '') // Enviar sin puntos
  };
  return axios.post(`${ApiServelUrl}/utils/validacedula`, body);
}
